import React from "react";

export const DIVIDER = "__DIVIDER__";

/**
 * Values are handed back to onValueChanged untouched, so callers get whatever
 * they put in. ReservationListSettings relies on that: it passes numeric status
 * constants and compares the result with indexOf(RC.STATUS.COMPLETE).
 */
type TOption<T> = {
    value: T;
    label: string;
    selected?: boolean;
    disabled?: boolean;
};

type TMultiSelectProps<T> = {
    className?: string;
    onValueChanged: (values: T[]) => void;
    options: TOption<T>[];
};

// The trailing comma in <T,> keeps TSX from reading it as a JSX tag.
const MultiSelect = <T extends string | number>(props: TMultiSelectProps<T>) => {
    const onChange = (value: T, evt: React.ChangeEvent<HTMLInputElement>) => {
        let values = props.options
            .filter((option) => option.selected)
            .map((option) => option.value);

        if (evt.target.checked) {
            values = values.concat(value);
        } else {
            values = values.filter((existingValue) => existingValue !== value);
        }

        props.onValueChanged(values);
    };

    return (
        <div className={props.className || ""}>
            {props.options.map((option, index) => {
                if (option.value === DIVIDER) {
                    return (
                        <div key={`divider${index}`}>
                            <br />
                        </div>
                    );
                }
                return (
                    <div key={option.value}>
                        <input
                            type="checkbox"
                            id={String(option.value)}
                            checked={option.selected || false}
                            value={option.value || ""}
                            onChange={onChange.bind(null, option.value)}
                            disabled={option.disabled || false}
                        />
                        <label htmlFor={String(option.value)}>{option.label}</label>
                    </div>
                );
            })}
        </div>
    );
};

export default MultiSelect;
